import { InjectionToken } from '@angular/core';

// * 글로벌 로딩이 필요한 API 호출에서 아래 토큰값을 키로 세팅하여 로딩여부를 세팅한다
export const HTTP_HEADER_LOADING = new InjectionToken<string>('httpRequest.headers.loading');
